import React from 'react';
import { Box, Container, Typography, Link, Divider, Stack, Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Link as RouterLink } from 'react-router-dom';

const linkSx = {
  fontFamily: 'Outfit',
  fontWeight: 400,
  fontSize: '0.9rem',
  color: 'rgba(255,255,255,0.55)',
  textDecoration: 'none',
  display: 'block',
  '&:hover': { color: '#004D40' },
  transition: 'color 0.2s',
};

const FooterSection = () => {
  return (
    <Box sx={{ backgroundColor: '#000000', color: '#ffffff' }}>
      <Container maxWidth="lg">
        <Box sx={{ pt: { xs: 8, md: 10 }, pb: 5 }}>
          <Grid container spacing={{ xs: 5, md: 4 }}>
            {/* Brand column */}
            <Grid size={{ xs: 12, md: 4 }}>
              <Box
                component="img"
                src="./logo-white.png"
                alt="Company Logo"
                sx={{ height: 30, mb: 2.5 }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <Box
                component="img"
                src="./companynamelogowhite_32.png"
                alt="Sigmatiqa"
                sx={{ display: 'none', height: 30, mb: 2.5 }}
              />
              <Typography
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 300,
                  fontSize: '0.9rem',
                  color: 'rgba(255,255,255,0.5)',
                  lineHeight: 1.8,
                  maxWidth: 280,
                  mb: 3,
                }}
              >
                Remote temperature monitoring for compliance, safety, and
                operational efficiency.
              </Typography>
              <Button
                href="https://app.sigmatiqa.com"
                disableElevation
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 500,
                  fontSize: '0.85rem',
                  textTransform: 'none',
                  backgroundColor: '#004D40',
                  color: '#ffffff',
                  px: 3,
                  py: 1,
                  borderRadius: '5px',
                  '&:hover': { backgroundColor: '#00695C' },
                  transition: 'background-color 0.2s',
                }}
              >
                Log in to Dashboard
              </Button>
            </Grid>

            {/* Products */}
            <Grid size={{ xs: 6, sm: 3, md: 2 }}>
              <Typography
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 700,
                  fontSize: '0.85rem',
                  color: '#ffffff',
                  mb: 2,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                }}
              >
                Products
              </Typography>
              <Stack spacing={1.25}>
                <Link component={RouterLink} to="/darwin" sx={linkSx}>
                  Darwin
                </Link>
                <Link component={RouterLink} to="/eden" sx={linkSx}>
                  Eden
                </Link>
              </Stack>
            </Grid>

            {/* Resources */}
            <Grid size={{ xs: 6, sm: 3, md: 2 }}>
              <Typography
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 700,
                  fontSize: '0.85rem',
                  color: '#ffffff',
                  mb: 2,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                }}
              >
                Resources
              </Typography>
              <Stack spacing={1.25}>
                <Link component={RouterLink} to="/installation" sx={linkSx}>
                  Installation
                </Link>
                <Link component={RouterLink} to="/faqs" sx={linkSx}>
                  FAQs
                </Link>
              </Stack>
            </Grid>

            {/* Contact */}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Typography
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 700,
                  fontSize: '0.85rem',
                  color: '#ffffff',
                  mb: 2,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                }}
              >
                Get in touch
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 300,
                  fontSize: '0.9rem',
                  color: 'rgba(255,255,255,0.5)',
                  lineHeight: 1.8,
                }}
              >
                Interested in deploying our monitoring solution?
              </Typography>
              <Link
                href="mailto:sales@sigmatiqa.com"
                sx={{
                  ...linkSx,
                  display: 'inline',
                  color: '#004D40',
                  mt: 1,
                  '&:hover': { color: '#00897B' },
                }}
              >
                sales@sigmatiqa.com
              </Link>
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)' }} />

        <Box
          sx={{
            py: 3,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: 'space-between',
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Outfit',
              fontWeight: 300,
              fontSize: '0.8rem',
              color: 'rgba(255,255,255,0.3)',
            }}
          >
            &copy; {new Date().getFullYear()} Sigmatiqa Ltd. All rights reserved. Registered in England and Wales.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2.5 }}>
            <Link component={RouterLink} to="/privacy-policy" sx={{ ...linkSx, fontSize: '0.8rem', display: 'inline' }}>
              Privacy Policy
            </Link>
            <Link component={RouterLink} to="/terms-of-service" sx={{ ...linkSx, fontSize: '0.8rem', display: 'inline' }}>
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default FooterSection;
